import { render } from "./HomeAdminView.vue?vue&type=template&id=587a8602&scoped=true"
import script from "./HomeAdminView.vue?vue&type=script&lang=js"
export * from "./HomeAdminView.vue?vue&type=script&lang=js"

import "./HomeAdminView.vue?vue&type=style&index=0&id=587a8602&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587a8602"]])

export default __exports__